import React, { Fragment } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import logo from './logo.svg';
import './App.css';
import ItemStatusContainer from './pages/admin/item-status/item-status-container';
import Navbar from "./components/Navbar";
import ItemTypesContainer from "./pages/admin/item-types/item-types-container";
import ItemsContainer from "./pages/admin/items/items-container";
import SnackbarStatus from "./pages/shared/snackbar/SnackbarStatus";
import ForRentWigsContainer from "./pages/client/for-rent/for-rent-wigs/for-rent-wigs-container";
import ItemCategoriesContainer from "./pages/admin/item-categories/item-categories-container";
import ForRentCostumesContainer from "./pages/client/for-rent/for-rent-costumes/for-rent-costumes-container";
import ForRentSetsContainer from "./pages/client/for-rent/for-rent-sets/for-rent-sets-container";
import ForSaleWigsContainer from "./pages/client/for-sale/for-sale-wigs/for-sale-wigs-container";
import ForSaleEssentialsContainer from "./pages/client/for-sale/for-sale-essentials/for-sale-essentials-container";
import ForRentCostumesDetailsContainer from "./pages/client/for-rent/for-rent-costumes/for-rent-costumes-details-container";
import ForRentSetsDetailsContainer from "./pages/client/for-rent/for-rent-sets/for-rent-sets-details-container";
import ForRentWigsDetailsContainer from "./pages/client/for-rent/for-rent-wigs/for-rent-wigs-details-container";
import ForSaleWigsDetailsContainer from "./pages/client/for-sale/for-sale-wigs/for-sale-wigs-details-container";
import ForSaleEssentialsDetailsContainer from "./pages/client/for-sale/for-sale-essentials/for-sale-essentials-details-container";
import LoginPage from "./pages/authentication/log-in/log-in";
import SignUpPage from "./pages/authentication/sign-up/sign-up";
import HomePage from "./pages/client/home-page/home-page";
import ItemsListDetailsContainer from "./pages/admin/items/items-list/items-list-details/items-list-details-container";
import BidsContainer from "./pages/admin/bids/bids-container";
import BidsItem from "./pages/client/bids/bids-item/bids-item";
import BidsHome from "./pages/client/bids/bids-home";
// import RequestRentForm from "./pages/client/request-rent/request-rent-form";
import RequestRentAgreement from "./pages/client/request-rent/request-rent-agreement";
import RequestRentForm from "./pages/client/request-rent/request-rent-form";
import RequestRentAgreementTemp from "./pages/client/request-rent/request-rent-agreement copy";
// import ItemPhotosContainer from "./pages/admin/item-photos/item-photos-container";

export default function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage/>} />
          <Route path="/admin/log-in" element={<LoginPage/>} />
          <Route path="/admin/sign-up" element={<SignUpPage/>} />
          <Route path="/admin/items" element={<ItemsContainer/>} />

          <Route path="/admin/items/details/:item_id" element={<ItemsListDetailsContainer/>} />
          {/* <Route path="/admin/item-photos" element={<ItemPhotosContainer/>} /> */}
          <Route path="/admin/item-types" element={<ItemTypesContainer/>} />
          <Route path="/admin/item-status" element={<ItemStatusContainer/>} />
          <Route path="/admin/item-categories" element={<ItemCategoriesContainer/>} />
          <Route path="/app/for-rent/wigs" element={<ForRentWigsContainer/>} />
          <Route path="/app/for-rent/costumes" element={<ForRentCostumesContainer/>} />
          <Route path="/app/for-rent/cosplay-sets" element={<ForRentSetsContainer/>} />
          <Route path="/app/for-sale/wigs" element={<ForSaleWigsContainer/>} />
          <Route path="/app/for-sale/cosplay-essentials" element={<ForSaleEssentialsContainer/>} />

          <Route path="/app/for-rent/costumes/details/:costume_id" element={<ForRentCostumesDetailsContainer/>} />
          <Route path="/app/for-rent/cosplay-sets/details/:set_id" element={<ForRentSetsDetailsContainer/>} />
          <Route path="/app/for-rent/wigs/details/:wig_id" element={<ForRentWigsDetailsContainer/>} />
          <Route path="/app/for-sale/wigs/details/:wig_id" element={<ForSaleWigsDetailsContainer/>} />
          <Route path="/app/for-sale/cosplay-essentials/details/:wig_id" element={<ForSaleEssentialsDetailsContainer/>} />
          
          <Route path="/app/request-rent/agreement" element={<RequestRentAgreement/>} />
          <Route path="/app/request-rent/agreement_temp" element={<RequestRentAgreementTemp/>} />
          <Route path="/app/request-rent/form" element={<RequestRentForm/>} />
          {/* <Route path="/reports" component={Reports} /> */}

          <Route path="/admin/bids/list" element={<BidsContainer/>} />
          <Route path="/app/bids" element={<BidsHome/>} />
          <Route path="/app/bids/item" element={<BidsItem/>} />
          {/* <Route path="/app/bids/:bid_id" element={<BidsItem/>} /> */}

        </Routes>
        <SnackbarStatus/>
      </Router>
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          This page is under construction.
        </p>
      </header> */}
      {/* <Navbar/> */}
      {/* <ItemStatusContainer/> */}
    </div>
  );
}

// export default App;
